import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

import { settlementScheduleOption, settlementSettingOption, weekOption } from "../../lib/constants";
import { settlementSchema } from "../../lib/validation";
import { api } from "../../utils/axios/Config";
import EditableBankAccount from "../main/loginzone/SelectComponents/EditableBankAccount";
import Loader from "../shared/Loader";
import ControlSelect from "../ui/ControlSelect";
import OptionInput from "./OptionInput";

export default function SettlementSettingForm({ data, type, id }) {
  const bussinessData = useSelector((store) => store.bussinessSlice.data);

  const settingData = {
    settlement_type: Number(data?.settlement_type),
    settlement_schedule: Number(data?.settlement_schedule),
    secondaryOption: Number(
      data?.settlement_schedule === 1
        ? null
        : data?.settlement_schedule === 2
          ? data?.day_of_the_week
          : data?.day_of_the_month,
    ),
  };

  const {
    watch,
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
  } = useForm({
    values: settingData,
    resolver: zodResolver(settlementSchema),
  });

  const [secondaryOptions, setSecondaryOptions] = useState([]);

  const settlementSchedule = Number(watch("settlement_schedule"));

  useEffect(() => {
    ////console.log(typeof(settlementSchedule), "settlementSchedulesettlementSchedule",settlementSchedule===2);
    if (settlementSchedule === 1) {
      setSecondaryOptions([]); // Disable the second select
    } else if (settlementSchedule === 2) {
      setSecondaryOptions(weekOption); // Set to week options
    } else if (settlementSchedule === 3) {
      const numberOptions = Array.from({ length: 21 }, (_, i) => ({
        value: i + 6,
        title: `${i + 6}`,
      }));
      setSecondaryOptions(numberOptions); // Set to numbers 6 to 26
    }
  }, [settlementSchedule, data]);

  const processForm = async (formdata) => {
    try {
      const { settlement_type, settlement_schedule, secondaryOption } = formdata;

      const settlementTypeNum = Number(settlement_type);
      const settlementScheduleNum = Number(settlement_schedule);
      const secondaryOptionNum = secondaryOption !== undefined ? Number(secondaryOption) : null;

      const payload = {
        settlement_type: settlementTypeNum,
        settlement_schedule: settlementTypeNum === 1 ? settlementScheduleNum : null,
        day_of_the_week:
          settlementTypeNum === 1 ? (settlementScheduleNum === 2 ? secondaryOptionNum : null) : null,
        day_of_the_month:
          settlementTypeNum === 1 ? (settlementScheduleNum === 3 ? secondaryOptionNum : null) : null,
      };

      const response = await api.patch(`/wallets/update/schedule/${data?.id}/`, payload);

      if (response.status === 200) {
        toast.success("تنظیمات تسویه اعمال گردید");
      } else {
        ////console.log("Unexpected response:", response);
      }
    } catch (error) {
      console.error("Error updating schedule:", error);
    }
  };

  return (
    <div className="flex flex-col justify-center items-end bg-neutral-10 mt-4 gap-1 mb-1 p-4 rounded-v-lg ">
      <hr />
      <form onSubmit={handleSubmit(processForm)} className="grid grid-cols-2 w-full gap-1 ">
        <p className="flex-1 font-bold md:text-title-lg-semibold pb-2">تنطیمات تسویه :</p>
        <div className="col-span-2  flex flex-col md:flex-row  gap-1 md:items-end  ">
          <EditableBankAccount
            className="min-w-[185px] max-w-[400px] flex-1  "
            label={" حساب بانکی"}
            name={"account_id"}
            user_id={bussinessData?.business?.user_id}
            value={bussinessData?.account?.id}
            disabled={false}
            type={type}
            id={id}
          />
          <OptionInput
            control={control}
            register={register}
            options={settlementSettingOption}
            name="settlement_type"
            className="max-w-[250px] col-span-2 flex-1"
          />

          {watch("settlement_type") === 1 && (
            <ControlSelect
              className="min-w-[185px] flex-1"
              control={control}
              name="settlement_schedule"
              label=""
              type={"number"}
              errors={errors.settlement_schedule}
              options={settlementScheduleOption}
            />
          )}

          {watch("settlement_type") === 1 && (
            <ControlSelect
              className="min-w-[185px] flex-1"
              control={control}
              name="secondaryOption"
              label=""
              type={"number"}
              errors={errors.secondaryOption}
              options={secondaryOptions}
              disabled={settingData?.settlementSchedule == 1}
            />
          )}
        </div>

        <div className="flex gap-2 self-end col-span-2 justify-end mt-6">
          <button type="submit" className="bg-dark  text-white  rounded-md text-[14px] p-1 md:p-4">
            {isSubmitting ? (
              <div className="flex gap-4 items-center">
                <p className="text-xs">در حال ارسال</p>
                <div className="flex-center gap-2 w-6 h-full">
                  <Loader />
                </div>
              </div>
            ) : (
              <p className=" px-2 text-title-lg-semibold">ذخیره تنطیمات تسویه </p>
            )}
          </button>
        </div>
      </form>
    </div>
  );
}
